module.exports = __webpack_public_path__ + "static/img/tutorial-product-price-2.8d8af11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-product-price-2.jpg
// module id = cEEl
// module chunks = 3